import classnames from 'classnames';
import { defineMessages } from 'react-intl';
import styled from 'styled-components';

import { Currency, MonetaryAmount } from '__generated__/globalTypes';
import discountCardFront from 'assets/rewards/discount-card-front.png';
import { Title2 } from 'atoms/typography';
import { useIntlContext } from 'contexts/intl';
import useAmountWithConversion from 'hooks/useAmountWithConversion';

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: var(--intermediate-unit);
  aspect-ratio: var(--card-aspect-ratio);
  background: center / cover no-repeat url(${discountCardFront});
`;

const Amount = styled(Title2)`
  color: #fecd11;
  font-family: Druk Wide;
  font-size: 40px;
  text-align: center;
  line-height: 1;
  max-width: 95%;
  word-break: break-word;
  &.long {
    font-size: 30px;
  }
`;

const Limit = styled.p`
  color: var(--c-static-neutral-100);
  font-family: Druk Wide;
  font-size: 16px;
  text-transform: uppercase;
  text-align: center;
`;

const messages = defineMessages({
  marketCredit: {
    id: 'ConversionCreditReward.marketCredit',
    defaultMessage: 'Market credit',
  },
  conversionReward: {
    id: 'ConversionCreditReward.arial-label',
    defaultMessage: 'Conversion reward',
  },
});

type Props = {
  monetaryAmount: MonetaryAmount;
};

export const FrontConversionCreditReward = ({ monetaryAmount }: Props) => {
  const { formatMessage } = useIntlContext();
  const { main } = useAmountWithConversion({
    monetaryAmount,
    primaryCurrency: Currency.FIAT,
  });
  const mainAmountLength = main.length;

  return (
    <Wrapper>
      <Amount
        className={classnames({
          long: mainAmountLength > 5,
        })}
        aria-label={formatMessage(messages.conversionReward)}
      >
        {main}
      </Amount>
      <Limit>{formatMessage(messages.marketCredit)}</Limit>
    </Wrapper>
  );
};
